import { ensureFunction } from './utils/ensureFunction.js';
export function pipe(...fns) {
    return fns.reduceRight((f, g) => {
        let g_ = ensureFunction(g);
        return (...args) => f(g_(...args));
    }, ensureFunction(fns.pop()));
}
